import { render, staticRenderFns } from "./ChatWindowHeader.vue?vue&type=template&id=5420745a&scoped=true&"
import script from "./ChatWindowHeader.vue?vue&type=script&lang=js&"
export * from "./ChatWindowHeader.vue?vue&type=script&lang=js&"
import style0 from "./ChatWindowHeader.vue?vue&type=style&index=0&id=5420745a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5420745a",
  null
  
)

export default component.exports